import React, { Fragment } from 'react';

import CrossIcon from 'icons/ic-close.svg';

import Toast from 'components/application/Toast';

export default function ErrorList({ errorData, errorKeys, removeError }) {
  return (
    <ul className='toast-rack'>
      {errorKeys.map((errorKey) => (
        <Toast
          burn={removeError}
          contents={
            <>
              <div className='toast__icon tw-bg-red-600'>
                <CrossIcon
                  className='[&_polygon]:tw-fill-white'
                  height={20}
                  width={20}
                />
              </div>
              <div className='toast__text'>
                {errorData[errorKey].fullMessage}
              </div>
            </>
          }
          key={errorKey}
          modifiers='no-undo'
          toastKey={errorKey}
        />
      ))}
    </ul>
  );
}
